import React, { useState, useEffect } from 'react';
import { render } from '@react-email/render';
import {
  EmailHtml,
  EmailHead,
  EmailHeader,
  EmailFooter,
  JobAdBody,
  WeeklyBlogBody,
  JobAdItem,
  BlogPostItem,
  JobAdBodyHeader,
  JobAdBodyFooter,
  BlogPostHeader,
  WeeklyBlogBodyFooter,
} from '../../components/email/EmailTemplate';
import { ContentLayout } from '../components/Layout/components/ContentLayout';
import { Stack, Typography, Box } from '@mui/material';

const EmailTemplateDemo = () => {
  const [emailHtmlContent, setEmailHtmlContent] = useState('');

  const mockJobAds = [
    {
        BuyerLogoURL: 'http://localhost:3000/images/square_logo.png',
        BuyerName: 'City of Stockholm',
        Role: 'Senior System Architect',
        Slug: 'senior-system-architect-123',
    },
    {
        BuyerLogoURL: 'http://localhost:3000/images/square_logo.png',
        BuyerName: 'Delegon AB',
        Role: 'Lead Frontend Developer',
        Slug: 'lead-frontend-dev-456',
    }
  ];

  const mockBlogPosts = [
    {
        PictureURL: 'http://localhost:3000/images/Blog.png',
        Title: 'The Future of Public Tenders in Sweden',
        CreatorName: 'John Doe',
        Description: 'A deep dive into the changing landscape of public procurement and what it means for suppliers.',
        Slug: 'future-of-tenders-123',
        CreatorLogoURL: 'http://localhost:3000/images/square_logo.png',
    },
    {
        PictureURL: 'http://localhost:3000/images/Blog2.png',
        Title: 'Top 5 AI Tools for Market Analysis More Text Here to Test Text Wrapping',
        CreatorName: 'Jane Smith',
        Description: 'Discover the best AI-powered tools that can give you a competitive edge in market analysis.',
        Slug: 'top-5-ai-tools-456',
        CreatorLogoURL: 'http://localhost:3000/images/square_logo.png',
    },
    {
        PictureURL: 'http://localhost:3000/images/Blog.png',
        Title: 'A Guide to Sustainable Business Practices',
        CreatorName: 'Peter Jones',
        Description: 'Learn how to implement sustainable practices in your business for a better future. Learn how to implement sustainable practices in your business for a better future.',
        Slug: 'sustainable-business-789',
        CreatorLogoURL: 'http://localhost:3000/images/square_logo.png',
    },
    {
        PictureURL: 'http://localhost:3000/images/Blog.png',
        Title: 'Navigating the Complexities of GDPR',
        CreatorName: 'Susan White',
        Description: 'A comprehensive guide to ensure your business is fully compliant with GDPR regulations.',
        Slug: 'gdpr-compliance-101',
        CreatorLogoURL: 'http://localhost:3000/images/square_logo.png',
    },
  ];

  useEffect(() => {
    const generateEmailHtml = async () => {
      const fullEmail = (
        <EmailHtml>
          <EmailHeader />
          <JobAdBody jobAds={mockJobAds} />
          <WeeklyBlogBody blogPosts={mockBlogPosts} />
          <EmailFooter />
        </EmailHtml>
      );
      const html = await render(fullEmail);
      setEmailHtmlContent(html);
    };

    generateEmailHtml();
  }, []);

  return (
    <ContentLayout title="Email Template Demo">
      <Stack sx={{ p: 2, width: '100%' }}>
        <Typography variant="h4" gutterBottom>
          Email Template Demo
        </Typography>
        <Box
          sx={{
            border: '1px solid #ccc',
            width: '100%',
            overflowX: 'auto',
            mt: 2,
          }}
          dangerouslySetInnerHTML={{ __html: emailHtmlContent }}
        />
      </Stack>
    </ContentLayout>
  );
};

export default EmailTemplateDemo;
